import { ChangeEvent, useState } from 'react';
import { NJChatInput, NJChatInputActionButton } from '@engie-group/fluid-design-system-react';
import styles from './page.module.css';


export const ChatInput = ({
  disabled,
  sendMessage,
}: {
  disabled: boolean;
  sendMessage: (value: string) => void;
}) => {

  const [chatInputVal, setChatInputVal] = useState<string>("");

  const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === 'Enter' && !event.shiftKey && !('ontouchstart' in window)) {
      event.preventDefault();
      sendMessageInput(chatInputVal);
    }
  };

  const sendMessageInput = (value: string) => {
    sendMessage(
      value
    );
    setChatInputVal("");
  };

  return (
    <>
     <div className={styles["genai-sidebar-content-chat-input"]}>
      <NJChatInput.Root
        disabled={disabled}
        placeholder="Envoyez un message"
        onKeyDown={handleKeyDown}
        variant="ai"
        value={chatInputVal}
        onChange={(event: ChangeEvent<HTMLTextAreaElement>) => {
          const target = event.target;
          setChatInputVal(target.value);
        }}

        primary_action={
          <NJChatInputActionButton
            onClick={() => sendMessageInput(chatInputVal)}
          />
        }
      />
    </div>
    </>
  );
};
